import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { CASE_STUDIES } from '../mock';
import ClosingCTA from '../components/ClosingCTA';

export default function Industries() {
  const retailCases = CASE_STUDIES.filter((c) => ['sephora','al-futtaim','magrabi','fenix'].includes(c.slug));
  return (
    <div>
      <section className="pt-16 pb-10">
        <div className="dwx">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">Industries · Retail & Commerce</div>
          <h1 className="serif-tight text-[64px] md:text-[112px] leading-[0.92] mt-4">Enterprise retail<br />and commerce.</h1>
          <p className="mt-10 max-w-3xl text-[17px] leading-relaxed text-[#1A1A1A]/80">Our deepest domain. Multi-market operations, complex product and pricing estates, seasonal peaks that make a bad release expensive within minutes, and integration surfaces spanning commerce platforms, ERP, order management and store systems.</p>
        </div>
      </section>

      <section className="py-16 bg-[#F4F2EC]">
        <div className="dwx grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">Where it goes wrong</div>
            <h2 className="serif-tight text-[38px] md:text-[52px] leading-[0.98] mt-3">Failure modes we recognise on first look.</h2>
          </div>
          <div className="col-span-12 md:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              ['Multi-market drift', 'A checkout change ships in one region, breaks another two releases later. Nobody notices until conversion drops.'],
              ['Silent price errors', 'A rounding rule differs between the pricing service and the display layer. Off-by-a-cent adds up in weekly reporting.'],
              ['Legacy integration surface', 'Commerce speaks to ERP through a translation layer nobody has documented since a departed engineer left.'],
              ['Peak-season fragility', 'The release window closes for eight weeks. Every deferred fix becomes a January migration.'],
            ].map(([t, b]) => (
              <div key={t} className="rounded-[16px] bg-[#FBFAF6] p-6 border border-[#1A1A1A]/10">
                <div className="serif text-[20px]">{t}</div>
                <p className="mt-2 text-[13px] leading-relaxed text-[#1A1A1A]/75">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="dwx">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">Retail case studies</div>
          <h2 className="serif-tight text-[38px] md:text-[52px] leading-[0.98] mt-3">Work we have shipped in retail.</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
            {retailCases.map((c) => (
              <Link key={c.slug} to={`/work/${c.slug}`} className="group rounded-[24px] bg-[#F4F2EC] p-8 hover:bg-[#E8E4D9] transition-colors lift">
                <div className="flex items-center justify-between">
                  <div className="serif text-[28px]">{c.client}</div>
                  <ArrowUpRight size={20} className="text-[#1A1A1A]/40 group-hover:text-[#22A94F]" />
                </div>
                <div className="mono text-[11px] uppercase tracking-wider text-[#1A1A1A]/55 mt-1">{c.markets}</div>
                <div className="serif-tight text-[22px] mt-5 text-[#178838]">{c.outcome}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <ClosingCTA />
    </div>
  );
}
